import { FormattedMessage } from 'react-intl'

import { Button } from '@/components/atoms/Button/Button.tsx'

export type DashboardSignInFailure = 'signInFailed' | 'sessionExpired'

export interface DashboardSignInFailedPageProps {
  readonly reason?: DashboardSignInFailure
  readonly onRetry: () => void
  readonly onSignIn: () => void
  readonly onBackToPilote: () => void
}

export const DashboardSignInFailedPage = ({
  reason = 'signInFailed',
  onRetry,
  onSignIn,
  onBackToPilote,
}: DashboardSignInFailedPageProps) => (
  <main className="flex min-h-screen items-center justify-center px-6">
    <div className="flex max-w-lg flex-col gap-4 text-center">
      <h1 className="font-heading text-xl">
        <FormattedMessage id={reason === 'sessionExpired' ? 'session.expired.title' : 'session.signInFailed.title'} />
      </h1>
      <p className="text-sm text-gray-800">
        <FormattedMessage id={reason === 'sessionExpired' ? 'session.expired.body' : 'session.signInFailed.body'} />
      </p>
      <div className="flex flex-col-reverse justify-center gap-2 sm:flex-row sm:gap-4">
        <Button className="py-1.5" onClick={onBackToPilote}>
          <FormattedMessage id="session.signInFailed.backToPilote" />
        </Button>
        {reason === 'sessionExpired' ? (
          <Button variant="primary" className="py-1.5" onClick={onSignIn}>
            <FormattedMessage id="session.expired.signIn" />
          </Button>
        ) : (
          <Button variant="primary" className="py-1.5" onClick={onRetry}>
            <FormattedMessage id="session.signInFailed.retry" />
          </Button>
        )}
      </div>
    </div>
  </main>
)
